module.exports = __webpack_public_path__ + "img/bg_product_01_02@2x.1fb69c36.png";